/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = require('jquery');
const _ = require('underscore');
const log = require('app/scripts/debug/log');
const l = require('app/scripts/lib/localize');
const { featureFlagClient } = require('@trello/feature-flag-client');
const { showFlag, dismissFlag } = require('@trello/nachos/experimental');

// The Alerts class provides an interface for displaying alerts in the upper-right-hand corner of the Trello UI
// Each alert will have
// - A message to display for the user
// - A displayType string (info, confirm, warning, error)
// - An area string. Areas do not interfere with each others' alerts.
// - Optionally, an amount of time to persist before clearing
// Setting a new alert in a given area will clear old alerts in that area.
// Calling 'hide' will hide alerts in the specified area only
// Calling 'hideAll' will hide all alerts - never call this unless you're about
// to reload the page.

module.exports = new ((function () {
  const Cls = class {
    static initClass() {
      this.prototype._alerts = {};
    }

    _hide(area) {
      const alert = this._alerts[area];
      if (alert != null ? alert.timeout : undefined) {
        clearTimeout(alert.timeout);
      }
      delete this._alerts[area];
      $(`#notification_${area}`).remove();
      return this._showHideContainer();
    }

    _show(msg, fHtml, displayType, area, msTimeout) {
      let timeout;
      log('alerts', 'show', msg, fHtml, displayType, area, msTimeout);
      this._hide(area);
      if (msTimeout) {
        timeout = setTimeout(() => this.hide(area), msTimeout);
      }
      this._alerts[area] = { timeout };
      const $div = $('<div>')
        .attr('id', `notification_${area}`)
        .addClass(`app-alert-item mod-${displayType}`)
        .appendTo('#notification');
      if (fHtml) {
        $div.html(msg);
        $(`#notification_${area} .js-dismiss-alert`).one('click', () =>
          this.hide(area),
        );
      } else {
        $div.text(msg);
      }
      return this._showHideContainer();
    }

    // Deprecate Alerts in favor of Flags.
    _showFlag({ title, displayType, area, msTimeout }) {
      let appearance;
      switch (displayType) {
        case 'info':
        case 'warning':
        case 'error':
          appearance = displayType;
          break;
        case 'confirm':
          appearance = 'success';
          break;
        default:
          break; // undefined appearance is valid
      }
      showFlag({
        id: area,
        title,
        appearance,
        isAutoDismiss: !!msTimeout,
        msTimeout,
      });
    }

    _showHideContainer() {
      return $('#notification').toggle(!_.isEmpty(this._alerts));
    }

    show(key, displayType, area, msTimeout = undefined) {
      let data;
      if (Array.isArray(key)) {
        [key, data] = Array.from(key);
      } else {
        data = {};
      }
      const title = l(['alerts', key], data);
      return this.showLiteralText(title, displayType, area, msTimeout);
    }

    showLiteralText(text, displayType, area, msTimeout = undefined) {
      if (featureFlagClient.get('workflowers.ak-flag', false)) {
        return this._showFlag({ title: text, displayType, area, msTimeout });
      }
      this._show(text, false, displayType, area, msTimeout);
    }

    /**
     * Deprecating in favor of showFlag. If you need to implement a custom alert
     * during this migration, please reach out to @raymond.
     * @deprecated
     */
    showHtml(msgHtml, displayType, area, msTimeout) {
      return this._show(msgHtml, true, displayType, area, msTimeout);
    }

    flash(key, displayType, area) {
      return this.show(key, displayType, area, 2000);
    }

    hide(area) {
      log('alerts', 'hide', area);
      if (featureFlagClient.get('workflowers.ak-flag', false)) {
        dismissFlag(area);
        return;
      }
      return this._hide(area);
    }

    hideAll() {
      return (() => {
        const result = [];
        for (const area in this._alerts) {
          result.push(this.hide(area));
        }
        return result;
      })();
    }
  };
  Cls.initClass();
  return Cls;
})())();
